/*
 * Copyright (c) 2020. Sonrai Analytics Limited
 * Developed by Warren Dowey
 */

import * as uuid from '@base/node_modules/uuid';

import { Injectable, OnDestroy } from '@angular/core';
import { SessionHistoryService } from '@app/services/api-services/session-history/session-history.service';
import { SessionHistoryModel } from '@app/models/session-history.model';
import { Observable, Subscription } from 'rxjs';
import { OrganisationUserService } from '@app/services/api-services/organisation-users/organisation-user.service';

@Injectable()
export class AuthSessionRecorderService implements OnDestroy {
  private previousSessionId: string;
  private sessionHistorySubscription: Subscription;
  private organisationUserSubscription: Subscription;

  constructor(
    private sessionHistoryService: SessionHistoryService,
    private organisationUserService: OrganisationUserService
  ) {}

  recordSession(sessionId, userId): Observable<any> {
    const sessHistory = new SessionHistoryModel();
    return new Observable((observer) => {
      this.organisationUserSubscription = this.organisationUserService.setNewOrgUserSession(userId, sessionId).subscribe(
        () => {
          if (this.organisationUserSubscription) {
            this.organisationUserSubscription.unsubscribe();
          }
          if ((sessionId != this.previousSessionId || !this.previousSessionId) && sessionId) {
            sessHistory.sessionHistoryId = uuid.v4();
            sessHistory.sessionId = sessionId;
            sessHistory.userId = userId;
            // TODO GraphQL struggles with these dates in particular for some reason
            // sessHistory.createdAt = new Date();
            // sessHistory.updatedAt = new Date();
            this.sessionHistorySubscription = this.sessionHistoryService.insertData(sessHistory).subscribe(
              () => {
                if (this.sessionHistorySubscription) {
                  this.sessionHistorySubscription.unsubscribe();
                }
                this.previousSessionId = sessionId;
                observer.next();
                observer.complete();
              },
              () => {
                if (this.sessionHistorySubscription) {
                  this.sessionHistorySubscription.unsubscribe();
                }
                observer.error();
                observer.complete();
              }
            );
          } else {
            observer.next();
            observer.complete();
          }
        },
        () => {
          if (this.organisationUserSubscription) {
            this.organisationUserSubscription.unsubscribe();
          }
          observer.error();
          observer.complete();
        }
      );
    });
  }

  ngOnDestroy() {
    if (this.organisationUserSubscription) {
      this.organisationUserSubscription.unsubscribe();
    }
    if (this.sessionHistorySubscription) {
      this.sessionHistorySubscription.unsubscribe();
    }
  }
}
